import * as React from "react";
const MiraLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      d="M8.33696 3.7661C6.74839 0.788213 4.56445 2.31536 3.92217 3.7661C2.5019 6.52177 0.47378 11.4635 0.282232 15.2144C1.03928 9.88765 4.2985 8.54042 6.775 8.79901C8.75212 9.00546 10.6698 10.2704 11.9092 11.47L12.1941 10.9382C11.6774 10.4634 9.39747 5.95001 8.33696 3.7661Z"
      fill="white"
    />
    <path
      d="M13.5542 12.7096C15.7166 10.794 17.6098 9.25817 18.7354 9.29448C19.6584 9.29448 20.3047 10.1709 20.7538 11.2894C18.9305 3.28924 17.576 2.45248 16.4024 2.82776C14.6055 3.6764 13.9427 7.93165 12.1941 10.9382L11.9092 11.47C11.1987 12.778 10.3053 14.0494 9.31732 15.2144C7.70433 17.1163 6.53506 19.0382 4.10447 19.7646C6.83704 18.948 10.4695 15.4423 13.5542 12.7096Z"
      fill="white"
    />
    <path
      d="M0.282232 15.2144C0.191474 16.9916 0.513024 18.5015 1.5069 19.3849C2.1993 20.0003 3.08986 20.0678 4.10447 19.7646C6.53506 19.0382 7.70433 17.1163 9.31732 15.2144C3.64927 18.1174 4.86708 12.4119 6.775 8.79901C4.2985 8.54042 1.03928 9.88765 0.282232 15.2144Z"
      fill="white"
    />
    <path
      d="M19.2324 18.8632C21.909 19.8118 21.7393 16.1892 21.7243 15.979C21.7148 15.8461 21.5254 13.2107 20.7538 11.2894C20.3047 10.1709 19.6584 9.29448 18.7354 9.29448C17.6098 9.25817 15.7166 10.794 13.5542 12.7096C16.2997 13.8856 16.4591 17.8804 19.2324 18.8632Z"
      fill="white"
    />
    <path
      d="M13.5542 12.7096C15.7166 10.794 17.6098 9.25817 18.7354 9.29448C19.6584 9.29448 20.3047 10.1709 20.7538 11.2894M13.5542 12.7096C16.2997 13.8856 16.4591 17.8804 19.2324 18.8632C21.909 19.8118 21.7393 16.1892 21.7243 15.979C21.7148 15.8461 21.5254 13.2107 20.7538 11.2894M13.5542 12.7096C10.4695 15.4423 6.83704 18.948 4.10447 19.7646M12.1941 10.9382C11.6774 10.4634 9.39747 5.95001 8.33696 3.7661C6.74839 0.788213 4.56445 2.31536 3.92217 3.7661C2.5019 6.52177 0.47378 11.4635 0.282232 15.2144M12.1941 10.9382L11.9092 11.47M12.1941 10.9382C13.9427 7.93165 14.6055 3.6764 16.4024 2.82776C17.576 2.45248 18.9305 3.28924 20.7538 11.2894M11.9092 11.47C10.6698 10.2704 8.75212 9.00546 6.775 8.79901M11.9092 11.47C11.1987 12.778 10.3053 14.0494 9.31732 15.2144M0.282232 15.2144C0.191474 16.9916 0.513024 18.5015 1.5069 19.3849C2.1993 20.0003 3.08986 20.0678 4.10447 19.7646M0.282232 15.2144C1.03928 9.88765 4.2985 8.54042 6.775 8.79901M4.10447 19.7646C6.53506 19.0382 7.70433 17.1163 9.31732 15.2144M6.775 8.79901C4.86708 12.4119 3.64927 18.1174 9.31732 15.2144"
      stroke="#013153"
      strokeWidth={0.296174}
    />
  </svg>
);
export default MiraLogo;
